import FTLToolbar from "./components/FTLToolbar";
export default FTLToolbar;
//# sourceMappingURL=index.js.map